var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',{ref:"googleMap",attrs:{"id":"googleMap"}},[_c('el-row',[_c('el-col',[(
            Boolean(this.loader) && Boolean(this.map) && Boolean(this.google)
          )?[_vm._t("default",null,{"loader":_vm.loader,"map":_vm.map,"google":_vm.google})]:_vm._e()],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }